<div
  (click)="fileInput.click()"
  class="flex justify-center items-center w-full h-full cursor-pointer relative"
>
  <img
    *ngIf="currentFile() || localImageLink()"
    class="w-full h-full z-40 opacity-40 absolute rounded-box object-cover"
    [src]="localImageLink() || currentFile()"
    alt=""
  />
  <div
    class="flex justify-center items-center gap-2 z-50 relative w-full h-full"
  >
    <i
      *ngIf="!loading() && !(!!currentFile() || !!localImageLink())"
      class="fa-solid fa-upload text-neutral-400 text-3xl"
    ></i>
    <i
      *ngIf="
        (!loading() && !!currentFile()) || (!loading() && !!localImageLink())
      "
      class="fa-solid fa-trash text-error p-2 text-xl"
    ></i>
    <span
      *ngIf="loading()"
      class="loading loading-spinner text-neutral-400 size-8"
    ></span>
  </div>
  <input
    [disabled]="disabled()"
    #fileInput
    type="file"
    hidden
    (change)="onFileSelected($event)"
  />
</div>
